import { AxiosResponse } from "axios";
import { axiosInstanceV2 } from "api/global";
import { handleApiError } from "api/helpers";

import {
    ConversionsEventRequest,
    ConversionsEventResponse,
} from "./conversions.types";

export const sendConversionsEvent = async (data: ConversionsEventRequest) =>
    await axiosInstanceV2
        .post("/attraction-service/conversion/v1/facebook/event", {
            ...data,
            eventTime: Math.round(new Date().getTime() / 1000),
        })
        .then((response: AxiosResponse<ConversionsEventResponse>) => {
            return response.data;
        })
        .catch(handleApiError);
